// src/routes/dashboard/components/PipelineSection.tsx
/**
 * Una card per tipologia di richiesta, con i conteggi per stato. Il click su un chip apre
 * la pagina tipo filtrata su quello stato (es. /pre-campionatura?status=7).
 */
import React from 'react';
import { Badge, Group, Stack, Text, ThemeIcon } from '@mantine/core';
import { useNavigate } from '@tanstack/react-router';
import { GinoriCard } from '../../../components/ui';
import { PipelineSection as PipelineSectionData, RequestStatus } from '../../../types/api';
import { STATUS_META } from '../../../components/analytics/analytics-meta';
import { SECTION_META, sectionStatusLabel } from '../dashboard-meta';

interface PipelineSectionProps {
  section: PipelineSectionData;
}

export function PipelineSection({ section }: PipelineSectionProps) {
  const navigate = useNavigate();
  const meta = SECTION_META[section.key];
  if (!meta) return null;

  const goToStatus = (status: RequestStatus) => {
    navigate({ to: meta.route, search: { status } } as any);
  };

  return (
    <GinoriCard>
      <Stack gap="sm">
        <Group justify="space-between" align="flex-start">
          <Group gap="xs">
            <ThemeIcon variant="light" color="gray" radius="sm" size="lg">
              <meta.icon size={20} stroke={1.5} />
            </ThemeIcon>
            <Text
              fw={500}
              style={{ fontFamily: '"Playfair Display", serif', color: 'var(--ginori-text-primary)' }}
            >
              {meta.label}
            </Text>
          </Group>
          <Group gap={6}>
            <Badge color="blue" variant="light" size="sm">
              {section.openCount} aperte
            </Badge>
            {section.overdueCount > 0 && (
              <Badge color="red" variant="light" size="sm">
                {section.overdueCount} in ritardo
              </Badge>
            )}
          </Group>
        </Group>

        <Group gap="xs">
          {section.statuses.map((s) => (
            <Badge
              key={s.status}
              color={STATUS_META[s.status]?.mantineColor ?? 'gray'}
              variant="dot"
              size="sm"
              style={{ cursor: 'pointer' }}
              onClick={() => goToStatus(s.status)}
            >
              {sectionStatusLabel(section.key, s.status)}: {s.count}
            </Badge>
          ))}
        </Group>
      </Stack>
    </GinoriCard>
  );
}
